import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import LabelFont from '../../../../Theme/Fonts/Label'
import NonFlexingContainer from '../../../../Layouts/NonFlexingContainer'

type Props = {
    text?: string
}

const PlayHighlight: FunctionComponent<Props> = ({ text = 'Highlights' }) => {
    return (
        <NonFlexingContainer
            backgroundColor="tahitian-4"
            height={22}
            spaceX="small"
            borderRadius={2}
            horizontal
            centerVertical
            centerHorizontal
        >
            <Grid noExpand marginRight={3}>
                <FontelloIcon name="play-active" fontSize="FS12" color="onyx" />
            </Grid>
            <LabelFont bold lineHeight="LH14" color="onyx">
                {text}
            </LabelFont>
        </NonFlexingContainer>
    )
}

export default PlayHighlight
